import {Component, EventEmitter, Input, OnChanges, OnInit, Optional, Output, SimpleChanges} from "@angular/core";
import * as _ from "lodash";
import {Formio} from "formiojs";
import { environment } from "../../../../environments/environment";
import { MyContentComponent } from "../../../models/formio/mycontent-component"; // #FormioUpgradeRemove
import { MyValidationBot } from "../../../models/formio/myvalidation-bot";
import { SelectWithAddComponent } from "../../../models/formio/select-with-add";
import { Registration } from "../../../models/registration";
import { RegistrationControllerService } from "../../../services/registration-controller/registration-controller.service";
import * as registrationSelection from "../../my-formio/components/registration-selection.json";
import * as tabDataBase from "../../my-formio/conf/base/tab-data.json";
import * as tabGeneralBase from "../../my-formio/conf/base/tab-general.json";
import * as tabValidationBase from "../../my-formio/conf/base/tab-validation.json";
import * as tabDataSelect from "../../my-formio/conf/tab-data-select.json";
import * as tabData from "../../my-formio/conf/tab-data.json";
import * as tabDeterminant from "../../my-formio/conf/tab-determinant.json";
import * as tabFormula from "../../my-formio/conf/tab-formula.json";
import * as tabGeneralEditGrid from "../../my-formio/conf/tab-general-editgrid.json";
import * as tabGeneralMyContent from "../../my-formio/conf/tab-general-mycontent.json";
import * as tabGeneralPanel from "../../my-formio/conf/tab-general-panel.json";
import * as tabGeneralTable from "../../my-formio/conf/tab-general-table.json";
import * as tabGeneralTextfield from "../../my-formio/conf/tab-general-textfield.json";
import * as tabGeneral from "../../my-formio/conf/tab-general.json";
import * as tabRegistration from "../../my-formio/conf/tab-registration.json";
import * as tabValidationCurrency from "../../my-formio/conf/tab-validation-currency.json";
import * as tabValidationDateTime from "../../my-formio/conf/tab-validation-datetime.json";
import * as tabValidationEditGrid from "../../my-formio/conf/tab-validation-editgrid.json";
import * as tabValidationNumber from "../../my-formio/conf/tab-validation-number.json";
import * as tabValidationTextfield from "../../my-formio/conf/tab-validation-textfield.json";
import * as tabValidation from "../../my-formio/conf/tab-validation.json";
import * as tabsWithFormula from "./conf/tabs-with-formula.json";
import * as tabs from "./conf/tabs.json";
import {AuthService} from "../../../services/auth/auth-service";
import {MyFormioComponent} from "../../my-formio/my-formio.component";

@Component({
  selector: "edit-form-field",
  templateUrl: "./edit-form-field.component.html",
})
export class EditFormFieldComponent implements OnInit, OnChanges {
  private restheartUrl: string = environment.RESTHEART_URL.slice(0, -1);

  @Input() public formData: any = {data: {viewMode: "basic"}};
  @Input() public serviceId: string;
  @Output() public saveFormSchema = new EventEmitter();
  public refreshForm = new EventEmitter();
  public form: any;
  private baseUrl: string = environment.BASE_URL.slice(0, -1);
  public determinantUrl: string;
  public triggersUrl: string;
  public formulaUrl: string;
  public tabTabsUrl: string;
  public tabTranslateUrl: string;
  public dynamicValidationUrl: string;
  public blacklistValidationUrl: string;
  public isAdvanceMode = false;

  // tab variables
  private TABS = 1;
  private TAB_GENERAL = 0;
  private TAB_DATA = 1;
  private TAB_VALIDATION = 2;
  private TAB_REGISTRATION = 3;
  private TAB_DETERMINANT = 4;
  private TAB_FORMULA = 5;

  constructor(private registrationService: RegistrationControllerService,
              private authService: AuthService) {
    Formio.registerComponent("mycontent", MyContentComponent); // shall be removed after formio upgrade in DS #FormioUpgradeRemove
    Formio.registerComponent("myvalidationbot", MyValidationBot); // must not be visible in toolbar
    Formio.registerComponent("selectwithadd", SelectWithAddComponent); // must not be visible in toolbar
  }

  public ngOnInit() {
    this.determinantUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/formiodeterminant";
    this.triggersUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/botstriggers";
    this.formulaUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/formioformula";
    this.tabTabsUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/formiotabs";
    this.tabTranslateUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/formiotranslate";
    this.dynamicValidationUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/formiovalidation/dynamic";
    this.blacklistValidationUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/formiovalidation/blacklist";
    this.loadServiceRegistrations();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.formData && changes.formData.currentValue) {
      this.formData = {}; // reset object
      this.formData.data = changes.formData.currentValue;
      this.loadSchemas();
    }
  }

  public loadSchemas(): void {
    const schema = this.getTabs(this.formData.data.type);
    this.defineEditWindow(schema);
    if (!this.form) {
      this.form = schema;
    }
    if (this.isAdvanceMode) {
      this.formData.data.viewMode = "advance";
    } else {
      this.formData.data.viewMode = "basic";
    }
    this.refreshForm.emit({
      submission: {
        data: this.formData.data,
      },
      form: schema,
    });
  }

  private getTabs(fieldType: string): any {
    if (fieldType === "number" || fieldType === "currency") {
      return this.getTabSchema(tabsWithFormula.default);
    } else {
      return this.getTabSchema(tabs.default);
    }
  }

  private defineEditWindow(schema: any) {
    if (this.formData) {
      // We can init tabs after serviceId is initialized
      const tabGeneralDefault = this.getMergeTabSchemas(tabGeneral.default, tabGeneralBase.default);
      const tabDataDefault = this.getMergeTabSchemas(tabData.default, tabDataBase.default);
      const tabValidationDefault = this.getMergeTabSchemas(tabValidation.default, tabValidationBase.default);
      const tabRegistrationJson = this.getTabSchema(tabRegistration.default);
      const tabDeterminantJson = this.getTabSchema(tabDeterminant.default);
      schema.components[this.TABS].components[this.TAB_GENERAL] = tabGeneralDefault;
      schema.components[this.TABS].components[this.TAB_DATA] = tabDataDefault;
      schema.components[this.TABS].components[this.TAB_VALIDATION] = tabValidationDefault;
      schema.components[this.TABS].components[this.TAB_REGISTRATION] = tabRegistrationJson;
      schema.components[this.TABS].components[this.TAB_DETERMINANT] = tabDeterminantJson;

      if (this.formData.data.type === "textfield") {
        schema.components[this.TABS].components[this.TAB_GENERAL] = this.getMergeTabSchemas(tabGeneralTextfield.default, tabGeneralBase.default);
        schema.components[this.TABS].components[this.TAB_VALIDATION] = this.getMergeTabSchemas(tabValidationTextfield.default, tabValidationBase.default);
        schema.components[this.TABS].components[this.TAB_FORMULA] = this.getTabSchema(tabFormula.default);
        schema.components[this.TABS].components.slice(0, -1);
      } else if (this.formData.data.type === "panel") {
        schema.components[this.TABS].components[this.TAB_GENERAL] = this.getMergeTabSchemas(tabGeneralPanel.default, tabGeneralBase.default);
      } else if (this.formData.data.type === "editgrid") {
        const tabGeneralEditGridJson = this.getMergeTabSchemas(tabGeneralEditGrid.default, tabGeneralBase.default);
        schema.components[this.TABS].components[this.TAB_GENERAL] = tabGeneralEditGridJson;
        schema.components[this.TABS].components[this.TAB_VALIDATION] = this.getMergeTabSchemas(tabValidationEditGrid.default, tabValidationBase.default);
      } else if (this.formData.data.type === "table") {
        const tabGeneralTableJson = this.getMergeTabSchemas(tabGeneralTable.default, tabGeneralBase.default);
        schema.components[this.TABS].components[this.TAB_GENERAL] = tabGeneralTableJson;
      } else if (this.formData.data.type === "select") {
        schema.components[this.TABS].components[this.TAB_DATA] = this.getMergeTabSchemas(tabDataSelect.default, tabDataBase.default);
      } else if (this.formData.data.type === "datetime") {
        const tabValidationDateTimeJson = this.getMergeTabSchemas(tabValidationDateTime.default, tabValidationBase.default);
        schema.components[this.TABS].components[this.TAB_VALIDATION] = this.getMergeTabSchemas(tabValidationDateTimeJson, tabValidationBase.default);
        schema.components[this.TABS].components[this.TAB_FORMULA] = this.getTabSchema(tabFormula.default);
      } else if (this.formData.data.type === "number") {
        schema.components[this.TABS].components[this.TAB_VALIDATION] = this.getMergeTabSchemas(tabValidationNumber.default, tabValidationBase.default);
        schema.components[this.TABS].components[this.TAB_FORMULA] = this.getTabSchema(tabFormula.default);
      } else if (this.formData.data.type === "currency") {
        schema.components[this.TABS].components[this.TAB_VALIDATION] = this.getMergeTabSchemas(tabValidationCurrency.default, tabValidationBase.default);
        schema.components[this.TABS].components[this.TAB_FORMULA] = this.getTabSchema(tabFormula.default);
      } else if (this.formData.data.type === "content" || this.formData.data.type === "mycontent") {
        const tabGeneralMyContentJson = this.getMergeTabSchemas(tabGeneralMyContent.default, tabGeneralBase.default);
        schema.components[this.TABS].components[this.TAB_GENERAL] = tabGeneralMyContentJson;
      }
    }
  }

  /*
   * Merge component base and specific schema files
   */
  private getMergeTabSchemas(schema1: any, schema2: any): string {
    schema1 = this.getTabSchema(schema1);
    schema2 = this.getTabSchema(schema2);
    const schema = _.mergeWith(schema1, schema2);
    if (!this.isAdvanceMode) {
      const filteredComponents1 = _.map(schema.components, (o: any) => {
        if (!o.ignore) { return o; }
      });

      // Remove undefines from the array
      schema.components = _.without(filteredComponents1, undefined);
    }
    // remove components without types
    const filteredComponents = _.map(schema.components, (o: any) => {
      if (o.type) { return o; }
    });
    schema.components = _.without(filteredComponents, undefined);
    return schema;
  }

  private async getToken() {
    return "Bearer " + await this.authService.getToken();
  }

  /*
   * Update json variables in json schema
   */
  private getTabSchema(defaultSchema: any) {
    let tabDataString = JSON.stringify(defaultSchema);
    tabDataString = tabDataString.split("$serviceId").join(this.serviceId);
    tabDataString = tabDataString.split("$baseUrl").join(this.baseUrl);
    tabDataString = tabDataString.split("$restheartUrl").join(this.restheartUrl);
    const schema = JSON.parse(tabDataString);
    MyFormioComponent.changeAuthPlaceholder(this.getToken.bind(this), schema);
    return schema;
  }

  public onSubmit(event: any) {
    if (event && event.data && (event.state === "submitted")) {
      if (event.data && event.data.type) {
        this.cleanEventData(event.data);
      }
      this.formData.data = event.data;
      this.saveForm();
    }
  }

  public onChange(event: any) {
    if (event.data && event.data.type) {
      this.cleanEventData(event.data);
    }
    if (event && event.changed && event.changed.instance
      && event.changed.instance.component.key === "viewMode") {
      this.isAdvanceMode = (event.changed.value === "advance");
      this.formData.data.viewMode = event.changed.value;
      this.loadSchemas();
    }
  }

  public cleanEventData(data: any) {
    if (data.type !== "table") {
      delete data.rows;
      delete data.numCols;
      delete data.numRows;
    }
    if (data.type !== "columns") {
      delete data.columns;
    }
    if (!data.type.match(/^(editgrid|row|column|panel|fieldset|container)$/)) {
      delete data.components;
    }
  }

  public saveForm() {
    this.saveFormSchema.emit(this.formData);
  }

  private loadServiceRegistrations() {
    tabRegistration.default.components = [];
    this.registrationService.getRegistrationsList(this.serviceId).subscribe(
      (data) => {
        const values = [];
        (data as Registration[]).forEach((item) => {
          values.push({
            label: item.name,
            value: item.id,
          });
        });
        registrationSelection.default.values = values;
        tabRegistration.default.components.push(registrationSelection.default);
      },
    );
  }
}
